import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';

import Category from './category';
import { GET_CARD_SORT_TEST_SESSION } from './graphql';

import {
  Container,
  Dialog,
  Header,
  List,
  ScrollBar,
} from './styles';

const CardSortModal = (props) => {
  const {
    onClose,
    show,
    hideCardName,
    testSessionId,
  } = props;

  const {
    data = {},
  } = useQuery(GET_CARD_SORT_TEST_SESSION, {
    variables: {
      testSessionId,
    },
  });

  let testSessionCardSortCategories = [];

  if (data?.testSessions && data?.testSessions.length > 0) {
    testSessionCardSortCategories = data?.testSessions[0]?.testSessionCardSortCategories || [];
  }

  return (
    <Container
      active={show}
      onClickOutside={onClose}
      page
    >
      <Dialog>
        <Header as="h3">Card Sort</Header>

        <List>
          <ScrollBar borderless>
            {!_.isEmpty(testSessionCardSortCategories) && _.map(testSessionCardSortCategories, (testSessionCategory) => (
              <Category
                key={testSessionCategory?.id}
                testSessionCategory={testSessionCategory}
                hideCardName={hideCardName}
              />
            ))}
          </ScrollBar>
        </List>
      </Dialog>
    </Container>
  );
};

CardSortModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  hideCardName: PropTypes.bool,
  testSessionId: PropTypes.string.isRequired,
};

CardSortModal.defaultProps = {
  show: false,
  hideCardName: false,
};

export default CardSortModal;
